import { lazyView } from '../../app/lazyView.js';
import type { ViewComponent } from '../../app/Shell.js';

// Layar kelompok "driver" → komponen (lihat features/PORTING.md). Dimuat terpisah (lazy).
export const views: Record<string, ViewComponent> = {
  tugas: lazyView(() => import('./Tugas.js')),
  muat: lazyView(() => import('./Muat.js')),
  antar: lazyView(() => import('./Antar.js')),
  setoran: lazyView(() => import('./Setoran.js')),
  peta: lazyView(() => import('../peta/Peta.js')),
};
